// extracted by mini-css-extract-plugin
module.exports = {"body":"ButtonMenu_body__1Ho-s","nav":"ButtonMenu_nav__Kjv83","navActiv":"ButtonMenu_navActiv__1RLyM"};